'use strict';

var toString = Object.prototype.toString

  , id = toString.call((function () { return arguments; }()));

module.exports = function (x) { return (toString.call(x) === id); };



//////////////////
// WEBPACK FOOTER
// ../~/es5-ext/function/is-arguments.js
// module id = 52
// module chunks = 0